import { FlexColumn } from 'ui-components/components/flex/column';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './account-info-summary.messages';
import { WwexEditLink } from './wwex-edit-link';
import style from './account-info-summary.module.less';

const EMPTY_DISPLAY = '—';
const EMPTY_VALUES = ['null', 'undefined', '<null>', '<undefined>'];

const getDisplayValue = (value: string) => {
  const trimmedValue = value.trim();
  return trimmedValue && !EMPTY_VALUES.includes(trimmedValue.toLowerCase()) ? trimmedValue : EMPTY_DISPLAY;
};

type AccountInfoSummaryProps = {
  contactFullName: string;
  companyName: string;
  email: string;
  phoneNumber: string;
  hasError?: boolean;
  isDisabled?: boolean;
  onEdit: () => void;
};

export const AccountInfoSummary = ({
  contactFullName,
  companyName,
  email,
  phoneNumber,
  hasError = false,
  isDisabled = false,
  onEdit,
}: AccountInfoSummaryProps) => (
  <FlexColumn className={style.container} gap={Gap.Space4}>
    <FlexRow className={style.headerRow} gap={Gap.Space8}>
      <Text isBold className={style.sectionTitle} textType={TextType.Label} value={messages.sectionTitle} />
      <WwexEditLink hasError={hasError} isDisabled={isDisabled} onClick={onEdit} />
    </FlexRow>
    <FlexColumn gap={Gap.Space4}>
      <Text className={style.readOnlyText} textType={TextType.Caption} value={getDisplayValue(contactFullName)} />
      <Text className={style.readOnlyText} textType={TextType.Caption} value={getDisplayValue(companyName)} />
      <Text className={style.readOnlyText} textType={TextType.Caption} value={getDisplayValue(email)} />
      <Text className={style.readOnlyText} textType={TextType.Caption} value={getDisplayValue(phoneNumber)} />
    </FlexColumn>
  </FlexColumn>
);
